import React, { useState } from "react";
import i18n from "i18next";

// Fabric Imports

import "./Academy.scss";

import useWindowSize from "../../helpers/useWindowSize";

import { Text } from "@fluentui/react-components";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";

function AcademyContentDE(props: { name: string }) {
  const windowSize = useWindowSize();

  return (
    <div className="lueb-ContentBlock">
      <div style={{ marginTop: 20 }}>
        {props.name == "LSP3APPLICATIONWORKSHOP" && (
          <div>
            <div>
              <h3>WISSEN, WORAUF ES ANKOMMT, WENN ES MAL ENG WIRD.</h3>
              <StackShim
                horizontal
                tokens={{ childrenGap: 10 }}
                wrap={true}
                horizontalAlign={
                  windowSize.width > 1024 ? "space-between" : "start"
                }
              >
                <StackItemShim
                  grow={1}
                  style={{ backgroundColor: " #faf9f8", padding: 20 }}
                >
                  <div className="lueb-listWithPlusIcon">
                    <h4>Inhalte</h4>
                    <ul>
                      <li>Vorstellung des L.SP3 Produktportfolios</li>
                      <div className="lueb-listNormal">
                        <ul>
                          <li>
                            Unterschiedliche Bauformen (Standard / Inline)
                          </li>
                          <li>Offene und geschlossene Schraubsysteme</li>
                          <li>Zusatzkomponenten für Schraubsysteme</li>
                          <li>Produkteigenschaften</li>
                        </ul>
                      </div>
                      <li>
                        Nutzung und Einsatzgebiete von L.SP3 Schraubsystemen
                      </li>
                      <li>
                        Zugänglichkeitsuntersuchungen mit dem L.SP3
                        Projektierungsset / 3D Daten
                      </li>
                      <li>
                        Möglichkeiten und Vorteile durch Nutzung der
                        Online-Plattform LÜBBERING DIGITAL
                      </li>
                      <li>
                        Konfiguration von L.SP3 Schraubsystemen im L.SP3
                        Configurator
                      </li>
                      <li>Vermeidung von Projektierungsfehlern</li>
                      <li>Vorstellung von Sonderlösungen</li>
                      <li>Anwendungsbeispiele</li>
                      <li>
                        Möglichkeiten und Vorteile durch Nutzung der
                        Online-Plattform LÜBBERING DIGITAL
                      </li>
                    </ul>
                  </div>
                </StackItemShim>

                <StackItemShim
                  grow={1}
                  style={{ backgroundColor: " #faf9f8", padding: 20 }}
                >
                  <h4>Durchführung</h4>
                  <div className="academy">
                    <div>
                      <u>Schulungsort:</u>
                    </div>
                    <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                    <div>
                      <u>Dauer:</u>
                    </div>
                    <div>1,5 bis 2 Tage</div>

                    <div>
                      <u>Teilnehmerzahl:</u>
                    </div>
                    <div>1 bis 6</div>

                    <div>
                      <u>Sprachangebot:</u>
                    </div>
                    <div>deutsch &amp; englisch</div>
                  </div>
                </StackItemShim>
                <StackItemShim
                  grow={1}
                  style={{ backgroundColor: " #faf9f8", padding: 20 }}
                >
                  <div className="lueb-listWithPlusIcon">
                    <h4>Beschreibung</h4>
                    <div style={{ marginTop: 10 }}></div>
                    <Text>
                      Mit dem weltweit größten Standardprogramm für Flachab
                      triebe bietet Ihnen LÜBBERING Lösungen für nahezu jeden
                      Schraubfall. Wir verschaffen Ihnen einen Überblick über
                      die gesamte standardisierte Bandbreite an LÜBBERING
                      Flachabtrieben, Winkelköpfen, Zusatzkomponenten und
                      Abtriebsprofilen. Wir zeigen Ihnen, wie Sie sich aus der
                      Vielzahl an Möglichkeiten das auf Ihre Anforderungen
                      passende Schraubsystem zusammenstellen. Lernen Sie die
                      Modularität unserer Produktwelt L.SP3 kennen und werden
                      Sie selbst Experte.
                    </Text>
                    <br></br>
                    <br></br>
                    <Text>
                      Wir zeigen Ihnen Ihre Möglichkeiten und Vorteile bei Nut
                      zung der Online-Plattform LÜBBERING DIGITAL, mit der Sie
                      beispielsweise Zugriff auf den L.SP3 Configurator oder den
                      L.SP3 Quick Finder, einer Schnellsuche für Schraub
                      system-Komponenten, haben. Darüber hinaus können Sie auch
                      Ihre Schraubsysteme zentral an einer Stelle team
                      übergreifend verwalten. In unserem Workshop erhalten Sie
                      alle wichtigen Informationen, die für Ihre Anwendungen
                      wichtig sind. Erfahren Sie zudem, wie Sie Fehler bei der
                      Projektierung vermeiden und wie Sie Zugänglichkeits
                      untersuchungen mit unserem L.SP3 Projektierungsset
                      durchführen können.
                    </Text>
                    <br></br>
                    <br></br>
                    <Text>
                      Ihr Nutzen: Sie erlangen Sicherheit im Umgang mit unserem
                      L.SP3 Projektierungsset und unserem L.SP3 Configurator und
                      finden schnellstmöglich das optimale L.SP3 Schraubsystem
                      für Ihre Anwendung. Profitieren Sie von diesem Know-how
                      und nutzen Sie es für Ihren individuellen Einsatz.
                    </Text>
                  </div>
                </StackItemShim>
              </StackShim>
            </div>
          </div>
        )}
        {props.name == "LSP3INSTALLATIONWORKSHOP" && (
          <div>
            <h3>DIE RICHTIGE EINSTELLUNG ZUR RICHTIGEN EINSTELLUNG.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau von L.SP3 Schraubsystemen</li>
                    <li>Inbetriebnahme von Schraubsystemen</li>
                    <li>Sicherer Umgang mit Schraubsystemen</li>
                    <li>Bedienung der Schraubsysteme</li>
                    <li>Vermeiden von Bedienungsfehlern</li>
                    <li>Durchführung einfacher Wartungstätigkeiten</li>
                    <li>dentifikation, Analyse und Behebung von Störungen</li>
                    <li>
                      Möglichkeiten und Vorteile durch Nutzung der Online
                      Plattform LÜBBERING DIGITAL
                    </li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div>
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING Academy oder bei Ihnen vor Ort</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>5 Stunden</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 6</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Der L.SP3 Installation Workshop richtet sich insbesondere an
                    das zuständige Einstellpersonal im Werk eines Auto mobil-
                    oder Flugzeugherstellers. In diesem Workshop lernen Sie von
                    unseren Experten, wie Sie Ihre LÜBBERING Schraubsysteme an
                    Ihre Tools adaptieren. Darüber hinaus werden Ihnen weitere
                    wissenswerte Inhalte zur Sicherheit und Inbetriebnahme von
                    L.SP3 Schraubsystemen vermit telt.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Wir zeigen Ihnen, wie sie selbstständig kleinere Wartungs
                    arbeiten an Ihrem Schraubsystem vornehmen können, um die
                    Langlebigkeit Ihrer L.SP3 Produkte sicherzustellen. Daneben
                    werden Sie von unseren Experten erfahren, worauf es bei der
                    Identifikation und Analyse von Störungen ankommt und
                    inwiefern Sie diese Störungen selbst beheben können.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Die Online-Plattform LÜBBERING DIGITAL bietet Ihnen die
                    Möglichkeit, alle technischen Produktdaten Ihrer L.SP3
                    Produkte jederzeit abzurufen. Sie registrieren Ihr Schraub
                    system – LÜBBERING DIGITAL gibt Ihnen Empfehlungen zu
                    vorbeugenden Wartungsmaßnahmen und berechneten
                    Schmierzyklen. In unserem Workshop erfahren Sie, wie das
                    funktioniert.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Sie möchten Ihr Schraubsystem L.SP3 selbst
                    adaptieren und in Betrieb nehmen? Funktionalität und
                    Sicherheit steht an erster Stelle – In unserem Workshop
                    vermitteln wir Ihnen Expertenwissen zur Inbetriebnahme,
                    Wartung und Störungsvermeidung.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LSP3OPERATORWORKSHOP" && (
          <div>
            <h3>
              MIT UNS WERDEN SIE PROFI IN DER ANWENDUNG IHRER SCHRAUBSYSTEME.
            </h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Sicherer Umgang mit L.SP3 Schraubsystemen</li>
                    <li>Bedienung der Schraubsysteme</li>
                    <li>Vermeiden von Bedienungsfehlern</li>
                    <li>Durchführung einfacher Wartungstätigkeiten</li>
                    <li>Erkennung von Störungen</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div>
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>Bei Ihnen vor Ort oder in der LÜBBERING Academy</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>3 Stunden</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 6</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    In dem L.SP3 Operator Workshop erfahren Anwender von
                    LÜBBERING Schraubsystemen alles über die optimale Bedienung
                    Ihrer im Einsatz befindlichen Werkzeuge. Unsere Experten
                    zeigen Ihnen, wie Sie Störungen vermeiden oder auch
                    frühzeitig erkennen und beheben können.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Erhalten Sie aus erster Hand Expertenwissen über die
                    optimale Bedienung und Handhabung und wo Sie Ihr
                    Schraubsystem anwenden können. Freuen Sie sich auf das
                    Schraubtechnik-Wissen unserer Experten und holen Sie das
                    Maximum aus Ihrem Schraubsystem heraus. Unser Ziel ist es,
                    dass Sie sicher mit Ihrem Schraubsystem arbeiten und so die
                    Produktlebensdauer erhöhen.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Ihr Nutzen: Lernen Sie in dem L.SP3 Operator Workshop alles
                    über die optimale Bedienung und Handhabung Ihrer L.SP3
                    Schraubsysteme.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}{" "}
        {props.name == "LSP3MAINTENANCEWORKSHOP" && (
          <div>
            <h3>
              PROFITIEREN SIE VON DEM KONSTANTEN EINSATZ IHRER SCHRAUBSYSTEME.
            </h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau von L.SP3 Schraubsystemen</li>
                    <li>Sicherer Umgang mit Schraubsystemen</li>
                    <li>Demontage von Schraubsystemen</li>
                    <li>
                      Identifikation und Analyse defekter oder abgenutzter
                      Bauteile
                    </li>
                    <li>
                      Störungsbehebung und Durchführung von komplexen
                      Wartungstätigkeiten
                    </li>
                    <li>Reparatur und Montage von Schraubsystemen</li>
                    <li>Wieder-Inbetriebnahme von Schraubsystemen</li>
                    <li>Vorstellung von Sonderlösungen</li>
                    <li>
                      Möglichkeiten und Vorteile durch Nutzung der Online
                      Plattform LÜBBERING DIGITAL
                    </li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div>
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>1 Tag</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 4</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Zuverlässige Verschraubungen auf engstem Raum erfordern
                    Flachabtriebe mit konstantem Wirkungsgrad und hoher
                    Genauigkeit. Zu erkennen, wann Verschleißteile zu ersetzen
                    sind und worauf es während der Demontage und Montage der
                    L.SP3 Schraubsysteme ankommt, ist hierbei entscheidend. Die
                    garantierte Standzeit von LÜBBERING Flachabtrieben kann bei
                    korrekter Wartung bei weitem übertroffen werden.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Lassen Sie sich von unserem hohen Qualitätsanspruch
                    anstecken und erfahren Sie in dem L.SP3 Maintenance Workshop
                    wie unsere Schraubsysteme aufgebaut sind, wie Sie die
                    Demontage und Montage korrekt durchführen und Ihr
                    Schraubsystem anschließend wieder korrekt in Betrieb nehmen.
                    Darüber hinaus stellen wir Ihnen Ihre Möglichkeiten und
                    Vorteile bei Nutzung unserer OnlinePlattform LÜBBERING
                    DIGITAL vor und zeigen Ihnen praxisnahe Anwendungsbeispiele.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Ihr Nutzen: Sie möchten die Lebensdauer Ihrer L.SP3
                    Schraubsysteme optimieren? Erkennen Sie, wann
                    Verschleißteile zu ersetzen sind und worauf es bei der
                    Demontage und Montage ankommt.Erlernen Sie, wie Sie
                    Wartungs- und Instandhaltungstätigkeiten selbständig und
                    korrekt durchführen.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}{" "}
        {props.name == "CUSTOMIZEDWORKSHOP" && (
          <div>
            <h3>AUSGERICHTET AUF IHRE INDIVIDUELLEN ANFORDERUNGEN.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau Ihres LÜBBERING Sonderschraubsystems</li>
                    <li>Sicherer Umgang mit Ihrem Sonderschraubsystem</li>
                    <li>
                      Inbetriebnahme und Bedienung Ihres Sonderschraubsystems
                    </li>
                    <li>Vermeiden von Bedienungsfehlern</li>
                    <li>Demontage Ihres Sonderschraubsystems</li>
                    <li>
                      Identifikation und Analyse defekter oder abgenutzter
                      Bauteile
                    </li>
                    <li>
                      Störungsbehebung und Durchführung notwendiger
                      Wartungstätigkeiten
                    </li>
                    <li>Montage Ihres Sonderschraubsystems</li>
                    <li>Wieder-Inbetriebnahme</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div>
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>1-2 Tag</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 4</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Schwierige Zugänglichkeiten und komplexe Montageprozesse bei
                    einem gleichzeitig hohen Qualitätsanspruch – das sind unsere
                    täglichen Herausforderungen. Mit unserem Team – aus
                    Verschraubungsexperten, Entwicklern und Konstrukteuren –
                    sind wir zusammen mit Ihnen in der Lage, auch in scheinbar
                    aussichtslosen Platzverhältnissen eine Lösung zu erarbeiten.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Lernen Sie in der LÜBBERING Academy oder bei Ihnen direkt
                    vor Ort zusammen mit unserem Expertenteam den Aufbau und den
                    sicheren Umgang mit Ihren Sonderschraubsystemen kennen. Von
                    der korrekten Inbetriebnahme und Bedienung Ihres
                    Sonderschraubsystems bis hin zur Montage und Demontage – Sie
                    sind für jeden Fall vorbereitet.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Im Customised Workshop zeigen wir Ihnen, wie Sie defekte und
                    abgenutzte Bauteile bei der Demontage identifizieren und
                    Störungen beheben können. Um einen dauerhaft reibungslosen
                    Einsatz Ihrer Sonderschraublösung zu gewährleisten, sind
                    regelmäßige Wartungstätigkeiten erforderlich. Schöpfen Sie
                    mit unserem wertvollen Exper tenwissen die volle Lebensdauer
                    der Schraubsysteme aus und erhalten Sie einen einzigartigen
                    Einblick in weitere LÜBBERING Sonderlösungen.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Ihr Nutzen: Sie erhalten individuell auf Ihr
                    Sonderschraubsystem zugeschnittene Informationen zur
                    Bedienung, Wartung und Störungsbehebung Ihres
                    Sonderschraubsystems.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
      </div>
      <div style={{ marginTop: 20 }}>
        {props.name == "LADUAPPLICATIONWORKSHOP" && (
          <div>
            <h3>BOHREN IST NICHT GLEICH BOHREN. WISSEN, WORAUF ES ANKOMMT.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <ul>
                    <li>Vorstellung des L.ADU Produktportfolios</li>
                    <div className="lueb-listNormal">
                      <ul>
                        <li>Unterschiedliche Maschinentypen</li>
                        <li>Elektronische und pneumatische L.ADU</li>
                        <li>Verriegelungssysteme</li>
                        <li>Zusatzkomponenten für Bohrsysteme</li>
                        <li>Produkteigenschaften</li>
                      </ul>
                    </div>
                    <li>Nutzung und Einsatzgebiete von L.ADU</li>
                    <li>Zugänglichkeitsuntersuchungen</li>
                    <li>Vermeidung von Projektierungsfehlern</li>
                    <li>Vorstellung von Sonderlösungen</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div style={{ marginTop: 10 }}></div>
                <div className="academy">
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>1 Tage</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 6</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              {/* <StackItemShim
                  grow={1}
                  style={{ backgroundColor: " #faf9f8", padding: 20 }}
                >
                  <h4>Durchführung</h4>
                  <div style={{ marginTop: 10 }}></div>

                  <div className="academy">
                    <div style={{ backgroundColor: "#e9e6e2", padding: 2 }}>
                      <u>Schulungsort:</u>
                      <p> LÜBBERING Academy (inkl.Verpflegung)</p>
                    </div>

                    <br></br>

                    <div style={{ backgroundColor: "#e9e6e2", padding: 2 }}>
                      <u>Dauer:</u>
                      <p> 1 Tage</p>
                    </div>

                    <br></br>

                    <div style={{ backgroundColor: "#e9e6e2", padding: 2 }}>
                      <u>Teilnehmerzahl:</u>
                      <p> 1 bis 6</p>
                    </div>

                    <br></br>

                    <div style={{ backgroundColor: "#e9e6e2", padding: 2 }}>
                      <u>Sprachangebot:</u>
                      <p> deutsch &amp; englisch</p>
                    </div>
                  </div>
                </StackItemShim> */}
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Bohren ist nicht gleich Bohren: Unterschiedliche
                    Materialien, Bohrer und Gegebenheiten in Fertigungsstätten
                    führen regelmäßig zu neuen Herausforderungen während der
                    Auswahl der passenden Maschinenkonfiguration.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Verstehen, was möglich ist und die optimale Lösung für Ihre
                    ganz spezielle Anwendung finden: mit unserem L.ADU
                    Application Workshop bieten wir Ihnen die Möglichkeit,
                    Prozesse aus einem anderen Blickwinkel zu betrachten. Durch
                    langjährige Erfahrung als Problemlöser in der Bohr technik
                    können wir auf die erfolgreiche Umsetzung von zahlreichen
                    Projekten zurückblicken.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Welcher Maschinentyp ist der Richtige für meine An wendung?
                    Welche Maschinenkonfiguration muss ich für meine
                    Materialkombination wählen? Diese und sehr viele weitere
                    Fragen beschäftigen unsere Kunden während der Projektierung
                    einer LÜBBERING Bohrmaschine. Der L.ADU Application Workshop
                    hilft Ihnen bei der Auswahl des richtigen Werkzeugs. Unsere
                    Experten erklären Ihnen, welche Möglichkeiten Sie haben, um
                    Ihren Bohrprozess zu optimieren und somit die Produktivität
                    zu steigern. Wir geben Ihnen Einblicke in die Entwicklung
                    und Funktions weise unserer hochpräzisen Werkzeuge der
                    Bohrtechnik. Lassen Sie sich von der Präzision, Ergonomie
                    und Flexibilität der pneumatischen und elektronischen
                    Bohrvorschubeinheiten L.ADU überzeugen.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Sie lernen unser umfangreiches L.ADU
                    Produktportfolio kennen und erfahren alles über die optimale
                    Maschinenkonfiguration für Ihre Anwendung. Profitieren Sie
                    von diesem Know-how und nutzen Sie es für Ihren
                    individuellen Einsatz.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}

        {props.name == "LADUINSTALLATIONWORKSHOP" && (
          <div>
            <h3>DIE RICHTIGE EINSTELLUNG ZUR RICHTIGEN EINSTELLUNG.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau einer L.ADU</li>
                    <li>Inbetriebnahme einer L.ADU</li>
                    <li>Software Funktionen einer L.ADU electronic</li>
                    <li>Vermeidung von Bedienungsfehlern</li>
                    <li>Durchführung von kleineren Wartungstätigkeiten</li>
                    <li>Sicherer Umgang mit einer L.ADU</li>
                    <li>Bedienung einer L.ADU</li>
                    <li>Identifikation und Analyse von Störungen</li>
                    <li>Behebung von Störungen</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div className="academy">
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING Academy oder bei Ihnen vor Ort</div>
                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>5 Stunden</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 6</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <Text>
                    Wie bei vielen Dingen, so ist es auch bei den
                    Bohrtechniklösungen der Fall: Eine Bohrmaschine bohrt nur so
                    gut wie Sie zuvor eingerichtet wurde. Wie Sie Ihre
                    Bohrmaschine L.ADU pneumatic oder L.ADU electronic richtig
                    einstellen und in Betrieb nehmen, zeigen wir Ihnen in
                    unserem L.ADU Installation Workshop.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Bei der Anwendung der komplexen Bohrmaschinen gibt es viele
                    Aspekte zu beachten. Im Installation Workshop lernen Sie den
                    sicheren Umgang mit einer elektronischen oder pneumatischen
                    L.ADU. Darüber hinaus erfahren Sie wie sich Bedienungsfehler
                    vermeiden lassen und Sie Störungen an der Bohrmaschine
                    identifizieren können. Für die Sicherstellung einer
                    dauerhaft optimalen Bohrqualität bedarf es kleinerer
                    Wartungsarbeiten an Ihrer L.ADU – diese können Sie nach dem
                    Workshop ganz einfach eigenständig vornehmen. Freuen Sie
                    sich auf viele neue Informationen, die Sie direkt in der
                    Praxis umsetzen können.
                  </Text>

                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Sie möchten Ihre Bohrmaschine L.ADU electronic
                    oder L.ADU pneumatic selbst in Betrieb nehmen?
                    Funktionalität und Sicherheit stehen an erster Stelle – In
                    unserem Workshop vermitteln wir Ihnen Expertenwissen zur
                    Inbetriebnahme, Wartung und Störungsvermeidung.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUOPERATORWORKSHOP" && (
          <div>
            <h3>
              DAMIT SIE UND IHR WERKZEUG PERFEKT AUFEINANDER ABGESTIMMT SIND.{" "}
            </h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Sicherer Umgang mit einer L.ADU</li>
                    <li>Bedienung der einer L.ADU</li>
                    <li>Vermeidung von Bedienungsfehlern</li>
                    <li>Erkennung von Störungen</li>
                    <li>Durchführung von kleineren Wartungstätigkeiten</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div className="academy">
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING Academy oder bei Ihnen vor Ort</div>
                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>3 Stunden</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 6</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <Text>
                    Der L.ADU Operator Workshop richtet sich an Sie als Anwender
                    einer pneumatischen oder elektronischen LÜBBERING Advanced
                    Drilling Unit und zeigt Ihnen, wie Sie Ihre L.ADU pneumatic
                    oder L.ADU electronic optimal für Anwendungen in der
                    Flugzeugmontage einsetzen. Hierzu erfahren Sie von unseren
                    Bohrtechnik-Experten alles zur Bedienung der Maschinen und
                    erhalten zudem nützliche Tipps im Handling.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Die Aspekte Sicherheit und Störungsbehebung sind ebenfalls
                    wichtige Punkte auf der Agenda des Workshops. Wir möchten,
                    dass Sie sich bei der Durchführung eines Bohrprozesses
                    absolut sicher in der Anwendung fühlen sowie Störungen
                    frühzeitig identifizieren und eigenständig beheben können.
                  </Text>

                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Erfahren Sie im Workshop alles über die optimale
                    Bedienung und Wartung einer L.ADU electronic oder L.ADU
                    pneumatic und profitieren Sie von dem konstanten Einsatz
                    Ihrer Bohrmaschine.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUMAINTENANCEWORKSHOP" && (
          <div>
            <h3>UNSERE MACHER ZEIGEN IHNEN, WIE MAN SELBER MACHER WIRD.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau einer L.ADU Bohrmaschine</li>
                    <li>Sicherer Umgang mit einer L.ADU Bohrmaschine</li>
                    <li>Demontage einer L.ADU Bohrmaschine</li>
                    <li>
                      Identifikation und Analyse defekter oder abgenutzter
                      Bauteile
                    </li>
                    <li>Vorstellung von Sonderlösungen</li>
                    <li>
                      Störungsbehebung und Durchführung von komplexen
                      Wartungstätigkeiten
                    </li>
                    <li>Reparatur & Montage einer L.ADU Bohrmaschine</li>
                    <li>Wieder-Inbetriebnahme einer L.ADU Bohrmaschine</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div className="academy">
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>1 – 2 Tage</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 4</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <Text>
                    LÜBBERING Advanced Drilling Units sind
                    Hochleistungsmaschinen, die Fertigungsprozesse verändern
                    können und die Produktivität signifikant steigern. Um die
                    dauerhafte Verfügbarkeit sicherzustellen, zeigen wir Ihnen
                    in unserem L.ADU Maintenance Workshop detailliert, wie Sie
                    Ihre L.ADU dauerhaft mit maximaler Performance betreiben
                    können. Steigern Sie die Lebensdauer Ihrer L.ADU mit unserer
                    Hilfe.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Im Fokus dieses Workshops steht die fachgerechte Wartung und
                    selbständige Reparatur unserer Produkte. Insbesondere der
                    direkte Kontakt zu unseren Bohrtechnik-Experten gibt
                    Anwendern die Möglichkeit, alle Fragen umgehend zu klären.
                  </Text>

                  <br></br>
                  <br></br>
                  <Text>
                    Mit einer Schulung, die genau auf die bei Ihnen im Einsatz
                    befindlichen Bohrmaschinen abgestimmt ist, sind Sie
                    anschließend in der Lage, Reparaturen und Wartungen an
                    unseren elektronischen oder pneumatischen Bohrmaschinen
                    L.ADU selbstständig und korrekt durchzuführen. Somit wird
                    die Lebensdauer und Standzeit Ihrer L.ADU entscheidend
                    erhöht.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Sie möchten die Lebensdauer Ihrer elektronischen
                    und pneumatischen L.ADU erhöhen? Erkennen Sie, wann
                    Verschleißteile zu ersetzen sind und worauf es bei der
                    Demontage und Montage ankommt. Erlernen Sie, in dem L.ADU
                    Maintenance Workshop, wie Sie Wartungs- und
                    Instandhaltungstätigkeiten selbständig und korrekt
                    durchführen.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUPROGRAMMINGWORKSHOP" && (
          <div>
            <h3>LERNEN SIE MIT UNS DIE DIGITALE WELT DES BOHRENS KENNEN.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Inhalte</h4>
                  <ul>
                    <li>Aufbau Ihrer L.ADU electronic</li>
                    <li>Sicherer Umgang mit Ihrer L.ADU electronic</li>
                    <li>Vorstellung des Smart Interface</li>
                    <li>Programmierung Ihrer L.ADU electronic</li>
                    <li>Inbetriebnahme Ihrer L.ADU electronic</li>
                    <li>Vermeidung von Bedienungsfehlern</li>
                    <li>Störungsbehebung</li>
                    <li>Anwendungsbeispiele</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Durchführung</h4>
                <div className="academy">
                  <div>
                    <u>Schulungsort:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (inkl.Verpflegung)</div>

                  <div>
                    <u>Dauer:</u>
                  </div>
                  <div>1 – 2 Tage</div>

                  <div>
                    <u>Teilnehmerzahl:</u>
                  </div>
                  <div>1 bis 4</div>

                  <div>
                    <u>Sprachangebot:</u>
                  </div>
                  <div>deutsch &amp; englisch</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <Text>
                    Für die optimale Einstellung der Bohrprozessparameter Ihrer
                    elektronischen Bohrmaschine L.ADU electronic, bieten wir
                    Ihnen den L.ADU Programming Workshop an.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Sie erlernen alle wichtigen Funktionen der Software des
                    L.ADU smart interface und können zukünftig bei veränder ten
                    Rahmenbedingungen oder Gegebenheiten Ihre Bohr
                    vorschubeinheit eigenständig programmieren. Darüber hinaus
                    erfahren Sie alles über die Digitalisierung Ihrer
                    Bohrprozesse und können sich direkt vor Ort mit unseren
                    Experten austauschen und beispielsweise Fragen zu den
                    Darstellungen der Grafiken und Tabellen innerhalb der
                    Softwarte stellen. Mit diesem technischen Wissen sind Sie
                    selbst in der Lage, die Dauer von Bohrungszyklen signifi
                    kant zu verkürzen und somit Ihre Bohrprozesse effizient zu
                    optimieren.
                  </Text>

                  <br></br>
                  <br></br>
                  <Text>
                    Dieser Workshop findet in unserem Bohrtechnik Testlabor
                    statt. Hier haben wir die Möglichkeit, unter realistischen
                    Gegebenheiten sowie unter Zuhilfenahme von verschiede nen
                    Materialmischpaketen und Bohrern, Live-Bohrungen
                    durchzuführen. Besuchen Sie den L.ADU Programming Workshop
                    und erleben Sie mit uns die digitale Welt des Bohrens.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Ihr Nutzen: Sie möchten Ihre Bohrprozesse optimieren und
                    effizienter arbeiten? Sie erhalten individuell auf Ihre
                    Bedürfnisse zugeschnittene Informationen zur optimalen
                    Programmierung Ihrer elektronischen Bohrmaschine L.ADU
                    electronic und lernen, diese eigenständig zu programmieren.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
      </div>
    </div>
  );
}

export default AcademyContentDE;
